<div class="dtf-accountdetails">

  <div class="container_dashboard" style="background-color: #e6e6e6; padding-top: 41px; padding-bottom: 21px;">
        <div style="background-color: #e6e6e6; padding-top: 21px; padding-bottom: 15px; padding-left: 21px; padding-right: 21px;">
        
          <a id="mbfs-header-login-cta" id="auto_triggeradminportal" class="mbfs-header-login-cta-a" href="javascript:void(0)" (click)="onClickAdminPortal($event)" hidden></a>

          <div *ngIf="(!this.dataLoaded)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
                <div class="demo-container">
                  <span>{{ 'Invoice.Loading' | translate }}</span>
                  <div class="progress-bar">
                    <div class="progress-bar-value"></div>
                  </div>
                </div>
                <br>
          </div>

           <div class="cardlike">
              <div>
                <h4 class="dtfbrochures__header_dark">Admin Portal</h4>
              </div>
            </div>
              <br><br><br>
          <div>
            <form #form="ngForm" *ngIf="!this.bodyLoaded && (!SelectAutopaySignup && !SelectAutopayTerminate && !SelectAutopayEdit)">
              <div class="example-button-row">
                <mat-button-toggle-group [hideSingleSelectionIndicator]="true" [value]="selectedAutopayState" (change)="onChangeAdminButton($event)">
                  <mat-button-toggle   [value]="toggleAutoPayEnum.Signup">Add User</mat-button-toggle>
                  <mat-button-toggle   [value]="toggleAutoPayEnum.Edit">Modify User</mat-button-toggle>
                </mat-button-toggle-group>
              </div>
            </form>
            <h4 class="dtfbrochures__header_dark" *ngIf="SelectAutopaySignup">Add User</h4>
            <h4 class="dtfbrochures__header_dark" *ngIf="SelectAutopayEdit">Modify User</h4>
            <div *ngIf="(!this.tableLoaded)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
              <!--Spinner on Login Load-->
              <div class="demo-container">
                <span>{{ 'Invoice.Loading' | translate }}</span>
                <div class="progress-bar">
                  <div class="progress-bar-value"></div>
                </div>
              </div>
              <br>
            </div>
            <div *ngIf="SelectAutopaySignup && !selectBankProfile">
              <form [formGroup]="adminPortalForm" *ngIf="openLoginModal">
                <div *ngIf="(!selectBankVerification)"> 
                  <div class="mbfs-modal-content">
                    <h5>Add New Admin User</h5>
                    <div class="mbfs-bank-profile-create-inner">
                      <div class="mbfs-text-form" [ngClass]="formValidationClasses">
                        <div class="form-group">
                          <div class="row">
                            <div class="col-md-6">
                              <b for="newUserId">User ID*</b><br>
                              <div class="col">
                                  <input class="form-control" type="text" [(ngModel)]="newUserId" name="newUserId" id="newUserId"
                                  formControlName="newUserId" required validateonblur value="" autocomplete="off">
                              </div>
                            </div>
                            <div class="col-md-6">
                              <b for="email">Email*</b><br>
                              <div class="col">
                                <input class="form-control" type="text" [(ngModel)]="email"  maxlength="60" name="email" id="email"
                                  formControlName="email" required validateonblur value="" autocomplete="off">
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-6">
                              <b for="firstName">First Name*</b><br>
                              <div class="col">
                                <input class="form-control" type="text" [(ngModel)]="firstName" maxlength="50"  name="firstName" id="firstName"
                                  formControlName="firstName" required validateonblur value="" autocomplete="off">
                              </div>
                            </div>
                            <div class="col-md-6">
                              <b for="lastName">Last Name*</b><br>
                              <div class="col">
                                <input class="form-control" type="text" [(ngModel)]="lastName"  maxlength="50" name="lastName" id="lastName"
                                  formControlName="lastName" required validateonblur value="" autocomplete="off">
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-6">
                                <span><b>Select Admin Status*</b></span>
                            </div>
                            <div class="col-md-6">
                              <div class="row" style="margin-top: 0%; margin-left: 0%;">
                              <b for="AdminType">Is Admin*: </b><br>
                              <div class="col" style="gap: 10%;">
                                <label>
                                  <input type="radio" value="A" [(ngModel)]="AdminType" formControlName="AdminType">
                                    <span>&nbsp;Admin&nbsp;</span>
                                </label>
                                <label>
                                  <input type="radio" value="R" [(ngModel)]="AdminType" formControlName="AdminType">
                                    <span>&nbsp;Regular</span>
                                </label>  
                                <label>
                                  <input type="radio" value="P" [(ngModel)]="AdminType" formControlName="AdminType">
                                    <span>&nbsp;Payment</span>
                                </label>  
                                <label>
                                  <input type="radio" value="M" [(ngModel)]="AdminType" formControlName="AdminType">
                                    <span>&nbsp;Marketing</span>
                                </label>  
                              </div>
                              </div>
                            </div>
                          </div>  
                          <div class="row" style="margin-top: 0%;">
                            <div class="col-md-6">
                                <span><b>Select Active Status*</b></span>
                            </div>
                            <div class="col-md-6">
                              <div class="row" style="margin-top: 0%;margin-left: 0%;">
                                <b for="ActiveStatus">Activate* : </b><br>
                                <div class="col" style="gap: 10%;">
                                  <label>
                                    <input type="radio" value="A"  [(ngModel)]="ActiveStatus" formControlName="ActiveStatus">
                                      <span>&nbsp;Yes&nbsp;</span>
                                  </label>
                                  <label>
                                    <input type="radio" value="I"  [(ngModel)]="ActiveStatus" formControlName="ActiveStatus">
                                      <span>&nbsp;No</span>
                                  </label>                            
                                </div>
                              </div>
                            </div>
                          </div><br>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <button type="submit" [disabled]="disableButton" (click)="saveAdminDetails('Add')" class="mbfs-button">Continue</button>
                  </div>
              </div>
              </form>
            </div>

            <div *ngIf="SelectAutopayEdit && !selectBankProfile">
              <div class="accountflex">
                <h1 class="mercedes-me-login__column-headline2"></h1>
                <mat-form-field class="example-form-field" appearance="outline">
                  <mat-label>{{ 'AccountDetails.Search' | translate }}</mat-label>
                  <input matInput  (keyup)="applyFilter($event)" placeholder="Account Number or Status" #input type="text" [(ngModel)]="value">
                  <img matSuffix class="example-form-img" src="/static/assets/img/dtf-assets/images/redesign/DTF_SearchButton_copy.png">
                </mat-form-field>
              </div>
              <div class="row">
                <div class="col">
                  <p>Please select up to 1 account per transaction for Auto Pay Edit.</p>
                </div>
              </div>
              <!-- <div *ngIf="(!this.tableLoaded)" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
                <div class="demo-container">
                  <span>{{ 'Invoice.Loading' | translate }}</span>
                  <div class="progress-bar">
                    <div class="progress-bar-value"></div>
                  </div>
                </div>
                <br>
              </div> -->
              <mat-table [dataSource]="dataSource" multiTemplateDataRows  class="mat-elevation-z8" matSort>
          <!--US/EN Table loading-->
            <ng-container matColumnDef="{{column.name}}" *ngFor="let column of initColumns; last as isLast; first as isFirst;">
              <div *ngIf="isFirst"> 
                <mat-checkbox  [ngClass]="{'white-border': !isChecked}" (change)="$event ? masterToggle() : null"
                [checked]="selection.hasValue()&& isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()">
            </mat-checkbox></div>
              <mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef>
                <div *ngIf="!isFrench"> {{column.display}}</div>
                <div *ngIf="isFrench"> {{column.displayFR}}</div>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <div *ngIf="isFirst"> 
                  <mat-checkbox (click)="$event.stopPropagation()"
                  (change)="$event ? selection.toggle(element) : null"
                  [checked]="selection.isSelected(element)">
                  </mat-checkbox>
                </div>
                <span class="mobile-label">
                  <div *ngIf="!isFrench"> {{column.display}} :</div>
                  <div *ngIf="isFrench"> {{column.displayFR}} :</div>
                </span>
                <div *ngIf="column.dispFormat=='currency'"> <!--Formats Currency Columns-->
                  {{element[column.name] | currency:'USD':true:'1.2-2'}}
                </div>
                <div *ngIf="column.dispFormat=='contract'"> <!--Formats Contract String Columns-->
                  {{element[column.name]}}
                </div>
                <div *ngIf="column.dispFormat==''"> <!--Formats String Columns-->
                  {{element[column.name]}}
                </div>
                <div *ngIf="column.dispFormat=='date'"> <!--Formats date Columns-->
                  {{element[column.name] | date:'MM/dd/yyyy'}}
                </div>
              </mat-cell>
            </ng-container>
    
            <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
          <ng-container matColumnDef="adminList">
            <mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
              [attr.colspan]="displayedColumns.length">
            </mat-cell>
          </ng-container>
    
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let element; columns: displayedColumns;"
              class="example-element-row"
              [class.example-expanded-row]="adminList === element"
              (click)="adminList = adminList === element ? null : element">
          </mat-row>
          <mat-row *matRowDef="let row; columns: ['adminList']" class="example-detail-row"></mat-row>
    
          <!-- Row shown when there is no matching data. -->
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="4" *ngIf="!isFrench">No data matching the filter "{{input.value}}"</td>
            <td class="mat-cell" colspan="4" *ngIf="isFrench">Aucune donnée correspondant au filtre "{{input.value}}"</td>
          </tr>
    
              </mat-table>
              <mat-paginator [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
              <button type="submit" [disabled]="!this.tableLoaded" (click)="openSelectedAdminEntity()" class="mbfs-button">Continue</button>
            </div>
            <div *ngIf="SelectAutopayEdit && selectBankProfile">
              <form [formGroup]="adminPortalForm" *ngIf="openLoginModal">
                <div> 
                  <div class="mbfs-modal-content">
                    <h5>Modify Existing Admin User</h5>
                    <div class="mbfs-bank-profile-create-inner">
                      <div class="mbfs-text-form" [ngClass]="formValidationClasses">
                        <div class="form-group">
                          <div class="row">
                            <div class="col-md-6">
                              <b for="newUserId">User ID*</b><br>
                              <div class="col">
                                  <input class="form-control" type="text" [(ngModel)]="newUserId" name="newUserId" id="newUserId"
                                  formControlName="newUserId" required validateonblur value="" autocomplete="off">
                              </div>
                            </div>
                            <div class="col-md-6">
                              <b for="email">Email*</b><br>
                              <div class="col">
                                <input class="form-control" type="text" [(ngModel)]="email"  maxlength="60" name="email" id="email"
                                  formControlName="email" required validateonblur value="" autocomplete="off">
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-6">
                              <b for="firstName">First Name*</b><br>
                              <div class="col">
                                <input class="form-control" type="text" [(ngModel)]="firstName" maxlength="50"  name="firstName" id="firstName"
                                  formControlName="firstName" required validateonblur value="" autocomplete="off">
                              </div>
                            </div>
                            <div class="col-md-6">
                              <b for="lastName">Last Name*</b><br>
                              <div class="col">
                                <input class="form-control" type="text" [(ngModel)]="lastName"  maxlength="50" name="lastName" id="lastName"
                                  formControlName="lastName" required validateonblur value="" autocomplete="off">
                              </div>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-md-6">
                                <span><b>Select Admin Status*</b></span>
                            </div>
                            <div class="col-md-6">
                              <div class="row" style="margin-top: 0%; margin-left: 0%;">
                              <b for="AdminType">Is Admin*: </b><br>
                              <div class="col" style="gap: 10%;">
                                <label>
                                  <input type="radio" value="A" [(ngModel)]="AdminType" formControlName="AdminType">
                                    <span>&nbsp;Admin&nbsp;</span>
                                </label>
                                <label>
                                  <input type="radio" value="R" [(ngModel)]="AdminType" formControlName="AdminType">
                                    <span>&nbsp;Regular&nbsp;</span>
                                </label>  
                                <label>
                                  <input type="radio" value="P" [(ngModel)]="AdminType" formControlName="AdminType">
                                    <span>&nbsp;Payment&nbsp;</span>
                                </label>  
                                <label>
                                  <input type="radio" value="M" [(ngModel)]="AdminType" formControlName="AdminType">
                                    <span>&nbsp;Marketing</span>
                                </label>  
                              </div>
                              </div>
                            </div>
                          </div>  
                          <div class="row" style="margin-top: 0%;">
                            <div class="col-md-6">
                                <span><b>Select Active Status*</b></span>
                            </div>
                            <div class="col-md-6">
                              <div class="row" style="margin-top: 0%;margin-left: 0%;">
                                <b for="ActiveStatus">Activate* : </b><br>
                                <div class="col" style="gap: 10%;">
                                  <label>
                                    <input type="radio" value="A"  [(ngModel)]="ActiveStatus" formControlName="ActiveStatus">
                                      <span>&nbsp;Yes&nbsp;</span>
                                  </label>
                                  <label>
                                    <input type="radio" value="I"  [(ngModel)]="ActiveStatus" formControlName="ActiveStatus">
                                      <span>&nbsp;No</span>
                                  </label>  
                                  <label>
                                    <input type="radio" value="R"  [(ngModel)]="ActiveStatus" formControlName="ActiveStatus">
                                      <span>&nbsp;Reset</span>
                                  </label>                                   
                                </div>
                              </div>
                            </div>
                          </div><br>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <button type="submit" [disabled]="disableButton" (click)="saveAdminDetails('Edit')" class="mbfs-button">Continue</button>
                  </div>
              </div>
              </form>
            </div>
          </div>
        </div>

  </div>



</div>